import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { ErrorBoundary } from 'components/errors/error-boundary';

import { DashboardLayout } from 'components/layouts/dashboard-layout';
import { Spinner } from 'components/ui/spinner';

export const AppRoot = () => {
    const location = useLocation();
    return (
        <DashboardLayout>
            <Suspense
                fallback={
                    <div className="flex size-full items-center justify-center">
                        <Spinner size="xl" />
                    </div>
                }
            >
                <ErrorBoundary key={location.pathname}>
                    <Outlet />
                </ErrorBoundary>
            </Suspense>
        </DashboardLayout>
    );
};
